// src/components/SidebarMenu/SidebarMenu.js
import React, { useState } from "react";
// Css
import "./sidebarmenu.css";
// Assets
import ClientLogo from "../../assets/client/ag_entrenamiento.png";
import OurLogo from "../../assets/gymhour/logo_gymhour.png";
import OurLogoBlack from "../../assets/gymhour/logo_gymhour_black.png";
// Iconos sidebar
import {
  Home,
  Calendar,
  CalendarPlus,
  Settings,
  LogOut,
  Activity,
  Notebook,
  CalendarCheck,
  Star,
  UserPlus,
  Users,
  Menu,
  X,
  DollarSign,
  UserCog,
  FileText,
  Dumbbell,
  FilePenLine
} from 'lucide-react';


// Routing
import { useNavigate, useLocation, Link } from "react-router-dom";
// Componentes
import ConfirmationPopup from "../utils/ConfirmationPopUp/ConfirmationPopUp";
import ThemeToggle from "../utils/ThemeToggle/ThemeToggle";

const SidebarMenu = ({ isAdmin, isEntrenador }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Theme state
  const [currentTheme, setCurrentTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  // Listen for theme changes on body attribute
  React.useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-theme') {
          const newTheme = document.body.getAttribute('data-theme');
          setCurrentTheme(newTheme || 'dark');
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });

    // Initial check in case it changed before observe
    const initialTheme = document.body.getAttribute('data-theme');
    if (initialTheme) {
      setCurrentTheme(initialTheme);
    }

    return () => observer.disconnect();
  }, []);

  const logoSrc = currentTheme === 'light' ? ClientLogo : ClientLogo;

  const handleLogoutClick = () => setIsPopupOpen(true);
  const handleLogoutConfirm = () => {
    setIsPopupOpen(false);
    localStorage.removeItem("token");
    navigate("/");
  };
  const handleLogoutCancel = () => setIsPopupOpen(false);

  const changePasswordPath = isAdmin ? "/admin/cambiar-contrasena" : (isEntrenador ? "/entrenador/cambiar-contrasena" : "/alumno/cambiar-contrasena");

  return (
    <>
      {/* Botón “Abrir” en mobile */}
      {/* <button
        className="hamburger-btn"
        onClick={() => setIsSidebarOpen(true)}
      >
        <MenuHamburguesaIcon
            className="icon"
            fill="#000000"
        />{" "}
      </button> */}

      {/* MOBILE NAVBAR: hamburguesa a la izquierda + logo centrado */}
      <header className="mobile-navbar">
        <button
          className="hamburger-btn"
          onClick={() => setIsSidebarOpen(prev => !prev)}
        >
          {isSidebarOpen
            ? <X size={35} className="svg-icon" />
            : <Menu size={20} className="svg-icon" />
          }
        </button>
        <img
          src={logoSrc}
          alt="Wembley Logo"
          className="mobile-logo"
        />
      </header>

      {/* Overlay semitransparente */}
      {isSidebarOpen && (
        <div
          className="overlay"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        {/* Botón “Cerrar” en mobile */}
        {/* <button
          className="close-btn"
          onClick={() => setIsSidebarOpen(false)}
        >
          <CloseIcon width={40} height={40} fill="#FAFAFA" />
        </button> */}

        {/* Logo cliente */}
        <div className="sidebar-logo">
          <img
            src={logoSrc}
            alt="Wembley Logo"
            className="logo"
          />
          <div className="menu-divider" />
        </div>

        {/* Menú */}
        <nav className="sidebar-menu">
          <h3 className="menu-title">MENÚ</h3>
          <ul className="menu-list">
            {
              // SIDEBAR ADMIN
              isAdmin ? (
                <>
                  <Link
                    to="/admin/inicio"
                    className={`menu-link ${location.pathname === "/admin/inicio"
                      ? "active"
                      : ""
                      }`}
                  >
                    <li className="menu-item">
                      <Home className="icon" />{" "}
                      Inicio
                    </li>
                  </Link>
                  <Link
                    to="/admin/turnos"
                    className={`menu-link ${location.pathname ===
                      "/admin/turnos"
                      ? "active"
                      : ""
                      }`}
                  >
                    <li className="menu-item">
                      <Calendar className="icon" />{" "}
                      Turnos
                    </li>
                  </Link>
                  <Link
                    to="/admin/clases-actividades"
                    className={`menu-link ${location.pathname ===
                      "/admin/clases-actividades"
                      ? "active"
                      : ""
                      }`}
                  >
                    <li className="menu-item">
                      <Activity className="icon" />{" "}
                      Clases y actividades
                    </li>
                  </Link>
                  <Link
                    to="/admin/usuarios"
                    className={`menu-link ${location.pathname === "/admin/usuarios"
                      ? "active"
                      : ""
                      }`}
                  >
                    <li className="menu-item">
                      <Users className="icon" />{" "}
                      Usuarios
                    </li>
                  </Link>
                  <Link
                    to="/admin/crear-usuario"
                    className={`menu-link ${location.pathname === "/admin/crear-usuario"
                      ? "active"
                      : ""
                      }`}
                  >
                    <li className="menu-item">
                      <UserPlus className="icon" />{" "}
                      Crear usuario
                    </li>
                  </Link>
                  <Link
                    to="/admin/ejercicios"
                    className={`menu-link ${location.pathname === "/admin/ejercicios"
                      ? "active"
                      : ""
                      }`}
                  >
                    <li className="menu-item">
                      <Dumbbell className="icon" />{" "}
                      Ejercicios
                    </li>
                  </Link>
                  <Link
                    to="/admin/asignar-rutinas"
                    className={`menu-link ${location.pathname === "/admin/asignar-rutinas" ? "active" : ""
                      }`}
                  >
                    <li className="menu-item">
                      <FilePenLine className="icon" /> Asignar Rutinas
                    </li>
                  </Link>
                  <Link
                    to="/admin/rutinas-asignadas"
                    className={`menu-link ${location.pathname === "/admin/rutinas-asignadas" ? "active" : ""
                      }`}
                  >
                    <li className="menu-item">
                      <FilePenLine className="icon" /> Rutinas Asignadas
                    </li>
                  </Link>
                  <Link
                    to="/admin/rutinas"
                    className={`menu-link ${location.pathname === "/admin/rutinas"
                      ? "active"
                      : ""
                      }`}
                  >
                    <li className="menu-item">
                      <Notebook className="icon" />{" "}
                      Rutinas recomendadas
                    </li>
                  </Link>
                  <Link
                    to="/admin/planes"
                    className={`menu-link ${location.pathname === "/admin/planes"
                      ? "active"
                      : ""
                      }`}
                  >
                    <li className="menu-item">
                      <FileText className="icon" />{" "}
                      Planes
                    </li>
                  </Link>
                  <Link
                    to="/admin/cuotas"
                    className={`menu-link ${location.pathname === "/admin/cuotas"
                      ? "active"
                      : ""
                      }`}
                  >
                    <li className="menu-item">
                      <DollarSign className="icon" />{" "}
                      Cuotas
                    </li>
                  </Link>
                </>
              )
                // SIDEBAR ENTRENADOR 
                : isEntrenador ? (
                  <>
                    <Link
                      to="/entrenador/inicio"
                      className={`menu-link ${location.pathname === "/entrenador/inicio" ? "active" : ""
                        }`}
                    >
                      <li className="menu-item">
                        <Home className="icon" /> Inicio
                      </li>
                    </Link>
                    <Link
                      to="/entrenador/turnos"
                      className={`menu-link ${location.pathname === "/entrenador/turnos"
                        ? "active"
                        : ""
                        }`}
                    >
                      <li className="menu-item">
                        <CalendarCheck className="icon" /> Turnos
                      </li>
                    </Link>
                    <Link
                      to="/entrenador/asignar-rutinas"
                      className={`menu-link ${location.pathname === "/entrenador/asignar-rutinas" ? "active" : ""
                        }`}
                    >
                      <li className="menu-item">
                        <FilePenLine className="icon" /> Asignar Rutinas
                      </li>
                    </Link>
                    <Link
                      to="/entrenador/rutinas-asignadas"
                      className={`menu-link ${location.pathname === "/entrenador/rutinas-asignadas" ? "active" : ""
                        }`}
                    >
                      <li className="menu-item">
                        <Notebook className="icon" /> Rutinas asignadas
                      </li>
                    </Link>
                    <Link
                      to="/entrenador/ejercicios"
                      className={`menu-link ${location.pathname === "/entrenador/ejercicios"
                        ? "active"
                        : ""
                        }`}
                    >
                      <li className="menu-item">
                        <Dumbbell className="icon" />{" "}
                        Ejercicios
                      </li>
                    </Link>
                    <Link
                      to="/entrenador/usuarios"
                      className={`menu-link ${location.pathname === "/entrenador/usuarios" ? "active" : ""
                        }`}
                    >
                      <li className="menu-item">
                        <Users className="icon" /> Usuarios
                      </li>
                    </Link>
                    <Link
                      to="/entrenador/crear-usuario"
                      className={`menu-link ${location.pathname === "/entrenador/crear-usuario" ? "active" : ""
                        }`}
                    >
                      <li className="menu-item">
                        <UserPlus className="icon" /> Crear usuario
                      </li>
                    </Link>
                    <Link
                      to="/entrenador/clases-actividades"
                      className={`menu-link ${location.pathname === "/entrenador/clases-actividades" ? "active" : ""
                        }`}
                    >
                      <li className="menu-item">
                        <Activity className="icon" /> Clases y actividades
                      </li>
                    </Link>
                  </>
                )
                  // SIDEBAR ALUMNO
                  : (
                    <>
                      <Link
                        to="/alumno/inicio"
                        className={`menu-link ${location.pathname === "/alumno/inicio"
                          ? "active"
                          : ""
                          }`}
                      >
                        <li className="menu-item">
                          <Home className="icon" />{" "}
                          Inicio
                        </li>
                      </Link>
                      <Link
                        to="/alumno/turnos"
                        className={`menu-link ${location.pathname === "/alumno/turnos"
                          ? "active"
                          : ""
                          }`}
                      >
                        <li className="menu-item">
                          <CalendarCheck className="icon" /> Mis turnos
                        </li>
                      </Link>
                      <Link
                        to="/alumno/agendar-turno"
                        className={`menu-link ${location.pathname ===
                          "/alumno/agendar-turno"
                          ? "active"
                          : ""
                          }`}
                      >
                        <li className="menu-item">
                          <CalendarPlus className="icon" /> Agendar turno
                        </li>
                      </Link>
                      <Link
                        to="/alumno/clases-actividades"
                        className={`menu-link ${location.pathname ===
                          "/alumno/clases-actividades"
                          ? "active"
                          : ""
                          }`}
                      >
                        <li className="menu-item">
                          <Activity className="icon" />{" "}
                          Clases y actividades
                        </li>
                      </Link>
                      <Link
                        to="/alumno/mi-rutina"
                        className={`menu-link ${location.pathname === "/alumno/mi-rutina"
                          ? "active"
                          : ""
                          }`}
                      >
                        <li className="menu-item">
                          <Notebook className="icon" /> Mi
                          rutina
                        </li>
                      </Link>
                      <Link
                        to="/alumno/ejercicios"
                        className={`menu-link ${location.pathname === "/alumno/ejercicios"
                          ? "active"
                          : ""
                          }`}
                      >
                        <li className="menu-item">
                          <Dumbbell className="icon" />{" "}
                          Ejercicios
                        </li>
                      </Link>
                      <Link
                        to="/alumno/medicion-resultados"
                        className={`menu-link ${location.pathname ===
                          "/alumno/medicion-resultados"
                          ? "active"
                          : ""
                          }`}
                      >
                        <li className="menu-item">
                          <Activity className="icon" /> Medición
                          de ejercicios
                        </li>
                      </Link>
                      <Link
                        to="/alumno/entrenadores"
                        className={`menu-link ${location.pathname === "/alumno/entrenadores"
                          ? "active"
                          : ""
                          }`}
                      >
                        <li className="menu-item">
                          <UserCog className="icon" /> Entrenadores
                        </li>
                      </Link>
                      <Link
                        to="/alumno/rutinas-recomendadas"
                        className={`menu-link ${location.pathname ===
                          "/alumno/rutinas-recomendadas"
                          ? "active"
                          : ""
                          }`}
                      >
                        <li className="menu-item">
                          <Star className="icon" /> Rutinas
                          recomendadas
                        </li>
                      </Link>
                      <Link
                        to="/alumno/cuotas"
                        className={`menu-link ${location.pathname ===
                          "/alumno/cuotas"
                          ? "active"
                          : ""
                          }`}
                      >
                        <li className="menu-item">
                          <DollarSign className="icon" /> Cuotas
                        </li>
                      </Link>
                    </>
                  )}
          </ul>

          <div className="profile-section">
            <h3 className="profile-title">PERFIL</h3>
            <ul className="menu-list">
              <Link
                to={changePasswordPath}
                className={`menu-link ${location.pathname === changePasswordPath ? "active" : ""
                  }`}
              >
                <li className="menu-item">
                  <Settings className="icon" /> Cambiar contraseña
                </li>
              </Link>

              <li className="menu-item">
                <ThemeToggle />
              </li>

              <li className="menu-item logout" onClick={handleLogoutClick}>
                <LogOut className="icon" /> Cerrar sesión
              </li>
            </ul>
          </div>

          <div className="sidebar-footer">
            <img
              src={logoSrc}
              alt="GymHour Logo"
              className="logo"
            />
          </div>
        </nav>

        <ConfirmationPopup
          isOpen={isPopupOpen}
          onClose={handleLogoutCancel}
          onConfirm={handleLogoutConfirm}
          message="¿Estás seguro de que desea cerrar sesión?"
        />
      </aside >
    </>
  );
};

export default SidebarMenu;
